import { api } from "constants/RotasAPI";
import useFetch from "hooks/useFetch";
import { toast } from "react-hot-toast";

type RequestAgendamentoContato = {
  agendamentoId: string | undefined;
};

export const useGetAgendamentoContatoEdicaoVisualizacao = (request: RequestAgendamentoContato) => {
  const onError = () => {
    toast.error("Erro ao buscar agendamento");
  };

  return useFetch<RequestAgendamentoContato>({
    key: ["agendamento-contato-edicao-visualizacao", request.agendamentoId],
    url: `${api.agendamentoContato.getAgendamentoContatoEdicaoVisualizacao}`,
    pathVariables: request.agendamentoId,
    onError,
    enabled: request.agendamentoId !== undefined,
  });
};
